import { useEffect, useState } from 'react';
import { AgentItem, api } from '../api';
import { ErrorBox, useAsync } from '../components/ui';
import { TOOL_LABEL } from '../api';

const TRIGGER_LABEL: Record<string, string> = {
  'crm.company.created': 'új cég felvételekor', 'crm.email.received': 'ismert kontakttól érkező új levélnél',
  'crm.deal.stage_changed': 'deal lépésváltásakor', 'crm.deal.stale': 'ha egy deal elakad', 'crm.quote.no_response': 'ha egy elküldött ajánlatra nem jön válasz',
  'crm.invoice.overdue': 'számla lejártakor', 'crm.import.uploaded': 'import feltöltésekor', 'crm.report.weekly': 'hétfő reggel (heti összefoglaló)',
};
const when = (x: AgentItem) => [
  ...(x.triggers.length ? [`Automatikusan: ${x.triggers.map((t) => TRIGGER_LABEL[t] ?? t).join('; ')}`] : []),
  ...(x.delegable ? ['ha egy adatlapon feladatot adsz neki'] : []), ...(x.report_qa ? ['ha a Riportok oldalon kérdezel tőle'] : []),
].join(' · ');

/** Beépített ügynökök be-/kikapcsolása és kapuhangolás (spec 7. fejezet). Csak AI-runtime mellett látszik (R7). */
export function AgentsPage() {
  const [data, setData] = useState<{ can_manage: boolean; items: AgentItem[] } | null>(null);
  const a = useAsync();
  const [at, setAt] = useState<string | null>(null); // melyik kártyán történt a művelet (ott jelenik meg a hiba)
  const load = () => a.run(async () => setData(await api('/agents')));
  useEffect(() => { load(); }, []);
  const set = async (id: string, body: { enabled?: boolean; require_approval?: boolean }) => {
    setAt(id);
    if (await a.run(() => api(`/agents/${id}`, { method: 'PUT', body }))) load();
  };
  return (
    <div>
      <div className="page-head"><h2>Ügynökök</h2></div>
      {!at && <ErrorBox error={a.error} />}
      {data && !data.can_manage && <p className="muted">Az ügynököket a tulajdonos kapcsolhatja be és állíthatja.</p>}
      {data?.items.map((x) => (
        <section key={x.id} className="card">
          <div className="card-head">
            <h3>{x.name}</h3>
            <span className={`badge ${x.enabled ? 'badge-agent' : ''}`}>{x.enabled ? 'bekapcsolva' : 'kikapcsolva'}</span>
            {data.can_manage && (
              <button className={x.enabled ? 'secondary' : ''} disabled={a.busy} onClick={() => set(x.id, { enabled: !x.enabled })}>
                {x.enabled ? 'Kikapcsolás' : 'Bekapcsolás'}
              </button>
            )}
          </div>
          {at === x.id && <ErrorBox error={a.error} />}
          <p className="muted" style={{ marginTop: 0 }}>{x.role}</p>
          <p>{x.description}</p>
          <dl className="props">
            <dt>Mikor dolgozik</dt><dd>{when(x)}</dd>
            <dt>Mit használhat</dt><dd>{x.tools.map((t) => <span key={t} className="tag">{TOOL_LABEL[t] ?? t}</span>)}</dd>
            <dt>Jóváhagyás</dt>
            <dd>
              <label className="check">
                <input type="checkbox" checked={x.require_approval} disabled={!data.can_manage || a.busy}
                       onChange={(e) => set(x.id, { require_approval: e.target.checked })} />
                Módosítás előtt kérjen jóváhagyást
              </label>
            </dd>
            <dt>E havi futások</dt><dd>{x.runs_this_month}{x.monthly_quota ? ` / ${x.monthly_quota}` : ''}</dd>
            <dt>AI nélkül</dt><dd className="muted">{x.without_ai}</dd>
          </dl>
        </section>
      ))}
    </div>
  );
}
